<template>
  <svg
    viewBox="0 0 24 24"
    :aria-labelledby="iconName"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    role="presentation"
    :width="widthValue"
    :height="heightValue"
    :fill="iconColor"
    :style="iconStyle"
    aria-hidden="true"
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path
      d="M11.99 2A10 10 0 1012 21.99 10 10 0 0011.99 2zM12 20a8 8 0 110-16 8 8 0 010 16zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    />
  </svg>
</template>

<script setup lang="ts">
import { defineProps, withDefaults } from 'vue';
import useIconSetUp from './useIconSetUp';

const props = withDefaults(
  defineProps<{
    iconName: string;
    iconColor?: string;
    fontSize?: string;
    width: string | number;
    height: string | number;
  }>(),
  {
    iconName: 'ClockIcon',
    iconColor: 'currentColor',
    fontSize: '1rem',
    width: 24,
    height: 24,
  },
);

const { widthValue, heightValue, viewBoxProp, iconStyle } = useIconSetUp(props);
</script>
